import { useaxios } from "../../../utils/useaxios";
export default (item_name, item_barcode, item_price, item_min_notification, item_min_sell_price, category_id, item_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('item/update.php', { item_name, item_barcode, item_price, item_min_notification, item_min_sell_price, category_id, item_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            clear();
        }
        // setloading(false);
    });
}